import React from 'react';
// import MaterialTable from "material-table";
import {Grid} from '@material-ui/core';
import {
  tablePageRows,
  defaultRows,
} from '../../../.../../../../../constants/ReusableTablePagination';
import {useSelector} from 'react-redux';
import PageLoader from '../../../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../../components/CustomSnackBar';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
export default function FilterGroupTable() {
  const {filterGroupData, isLoading, errorMsg, successMsg} = useSelector(
    ({filterGroup}) => filterGroup,
  );
  const data = filterGroupData?.filters ? filterGroupData?.filters.map((o) => ({...o})) : [];
  const columns = [
    {
      title: 'Seq No',
      field: 'seqNo',
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        maxWidth: 200,
        textAlign: 'center',
      },
      render: (rowData) => {
        const rowSeqNo = rowData?.tableData?.id ?
          rowData?.tableData?.id + 1 :
          rowData?.tableData?.id === 0 ?
            1 :
            '';
        return rowSeqNo;
      },
    },
    {
      title: 'Filter Code',
      field: 'name',
    },
    {
      title: 'Description',
      field: 'description',
    },
  ];

  return (
    <>
      <Grid item xs={12} className="">
        <div className="custom-table">
          <div className="form-row px-1 ">
            <div className="col form-group ">
              <b>Filter Group Code:</b> {filterGroupData.filterGroupCode}
            </div>
            <div className="col form-group ">
              <b>Filter Group Name:</b> {filterGroupData.filterGroupName}
            </div>
            <div className="col form-group ">
              <b>Filter Group Description:</b> {filterGroupData.filterGroupDescription}
            </div>
          </div>

          <GuiTable
            title=""
            columns={columns}
            data={data}
            options={{
              toolbar: false,
              search: false,
              pageSize: defaultRows,
              pageSizeOptions: tablePageRows,
              emptyRowsWhenPaging: false,
              paging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
          />
        </div>
        {isLoading && <PageLoader />}
        {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
        {successMsg && <SuccessSnackbar successMsg={successMsg} />}
      </Grid>
    </>
  );
}
